import React, { useMemo } from "react";
import { Tooltip, Typography } from "@mui/material";

import { objectToFormData } from "../../../../utils";
import { TooltipName } from "../../../../utils/Enums";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { useUserMutationDialog } from "../hooks/useUserMutationDialog";
import { getLogsDialogContent } from "../utils/userManagementUtils";

function Logs({ logRequired, params }) {
  const logsDialog = useUserMutationDialog({
    userId: params.row.user_id,
    initialValue: logRequired,
    createPayload: (status) => objectToFormData({ cardlog_required: !status }),
    getNextValue: (status) => !status,
  });

  const tooltipTitle = useMemo(() => {
    return logsDialog.value
      ? TooltipName.MANAGE_USER.DISABLE_WORKLOG_TRACKING
      : TooltipName.MANAGE_USER.ENABLE_WORKLOG_TRACKING;
  }, [logsDialog.value]);

  const dialogContent = useMemo(
    () => getLogsDialogContent(logRequired, logsDialog.value),
    [logRequired, logsDialog.value]
  );

  return (
    <>
      {logsDialog.isDialogOpen && (
        <FormDialog
          open={logsDialog.isDialogOpen}
          handleClose={logsDialog.closeDialog}
          handleSubmit={logsDialog.submit}
          loading={logsDialog.isSubmitting}
          buttonTxt={"Confirm"}
          title={"Confirmation: Change Worklog Status"}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            {dialogContent.message}
          </Typography>
        </FormDialog>
      )}
      <Tooltip title={tooltipTitle}>
        <div className="w-100 d-flex justify-content-center">
          <label className="custom-checkbox">
            <input
              type="checkbox"
              checked={logsDialog.value}
              onClick={logsDialog.openDialog}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </Tooltip>
    </>
  );
}

const isChangeLogs = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.user_id === nextProps?.params?.row?.user_id
    && prevProps?.logRequired === nextProps?.logRequired
  );
};

export default React.memo(Logs, isChangeLogs);
